import { noop } from 'lodash';
import React, { useState } from 'react';

type ModalClose = (() => void) | undefined;

interface ModalContext {
  onModalClose: ModalClose;
  addOnModalClose(value: (() => void) | React.MouseEventHandler<Element>): void;
  removeOnModalClose(): void;
  triggerModalClose(): void;
  isPrompt: boolean;
  setIsPrompt(value: boolean): void;
}

export const Context = React.createContext<ModalContext>({
  onModalClose: undefined,
  addOnModalClose: noop,
  removeOnModalClose: noop,
  triggerModalClose: noop,
  isPrompt: false,
  setIsPrompt: noop
});

const ModalProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [onModalClose, setOnModalClose] = useState<ModalClose>(undefined);
  const [isPrompt, setPrompt] = useState(false);

  return (
    <Context.Provider
      value={{
        onModalClose,
        addOnModalClose(value) {
          setOnModalClose(() => value);
        },
        removeOnModalClose() {
          setOnModalClose(undefined);
          setPrompt(false);
        },
        triggerModalClose() {
          if (onModalClose) {
            onModalClose();
            setOnModalClose(undefined);
            setPrompt(false);
          }
        },
        isPrompt,
        setIsPrompt(value) {
          setPrompt(value);
        }
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default ModalProvider;
